// extracted by mini-css-extract-plugin
export default {"base":"FluMap_base__xA5rl"};